import type { NewFolderDialogStore } from "./schema/NewFolderDialogStore";
import { createStore } from "owa-satcheljs";

/**
 * Selector to get UI store for folder permissions package
 */
export const getStore: () => NewFolderDialogStore = createStore<NewFolderDialogStore>("newFolderDialogStore", {
    shouldShow: false,
});
